import {createSelector} from 'reselect';
import {isEmptyDomain} from '../../utils/utils';
import {SessionDataGetSchema} from '../../api/DBSchema/SessionData';

// If userId is set, this is a sign that said user is authenticated - always
export const isAuthenticatedSelector = state => !!state.user.userId;
export const userIdSelector = state => state.user.userId;
export const currentPortalSelector = state => state.user.currentPortal;
export const portalTimeZoneSelector = state => state.user.portalTimeZone;
export const isEmptyPortalSelector = state => isEmptyDomain(state.user.currentPortal);
export const availablePortalsSelector = state => state.user.availablePortals;
export const availablePlansSelector = state => state.user.availablePlans;

export const isCyberViewsEnabledSelector = state => state.user.isCyberViewsEnabled;
export const isSMELogsEnabledSelector = state => state.user.isSMELogsEnabled;

export const userRoleSelector = state => state.user.userRole;
export const userRoleNameSelector = state => state.user.userRole ? state.user.userRole.name : undefined;
export const isUserAdminSelector = state => state.user.userRole ? state.user.userRole.isAdmin : undefined;
export const isSystemUserSelector = state => state.user.userRole ? state.user.userRole.isSystemUser : undefined;

export const isAdminReadOnlySelector = createSelector(
    isUserAdminSelector,
    userRoleNameSelector,
    (isAdmin, roleName) => {
        if (isAdmin) {
            return (
                roleName === SessionDataGetSchema.adminRoleValues.readOnly ||
                roleName === SessionDataGetSchema.adminRoleValues.multiDomainReadOnly
            );
        } else {
            return undefined;
        }
    }
);

export const isUserMultiDomainAdminSelector = createSelector(
    isUserAdminSelector,
    userRoleNameSelector,
    (isAdmin, roleName) => {
        return (
            isAdmin && (
                roleName === SessionDataGetSchema.adminRoleValues.multiDomain ||
                roleName === SessionDataGetSchema.adminRoleValues.multiDomainReadOnly
            )
        );
    }
);

export const canViewLogsSelector = state => state.user.userRole ? state.user.userRole.canViewLogs : undefined;

// Permissions
export const userPermissionsSelector = state => state.user.userRole ? state.user.userRole.userPermissions : undefined;
export const planPermissionsSelector = state => state.user.userRole ? state.user.userRole.planPermissions : undefined;
export const communityPermissionsSelector = state => state.user.userRole ? state.user.userRole.communityPermissions : undefined;
export const gatewayPermissionsSelector = state => state.user.userRole ? state.user.userRole.gatewayPermissions : undefined;
export const rolePermissionsSelector = state => state.user.userRole ? state.user.userRole.rolePermissions : undefined;
export const customImagePermissionsSelector = state => state.user.userRole ? state.user.userRole.customImagePermissions : undefined;
export const firmwarePermissionsSelector = state => state.user.userRole ? state.user.userRole.firmwarePermissions : undefined;
export const serviceDomainSettingsPermissionsSelector = state => state.user.userRole ? state.user.userRole.serviceDomainSettingsPermissions : undefined;
export const systemUserPermissionsSelector = state => (state.user.userRole && state.user.userRole.isSystemUser) ? state.user.userRole.systemUserPermissions : undefined;

export const availablePlansCountSelector = createSelector(availablePlansSelector, plans => plans ? plans.length : 0);